// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-eoc","icon":"styles_icon__3rQ5W"};